export { default }  from './PaymentMethods';


// WEBPACK FOOTER //
// ./src/components/Help/PaymentMethods/index.ts